export default "__VITE_ASSET__CFjlOc9v__"